// extracted by mini-css-extract-plugin
export default {"coverLink":"aS-z","contentBox":"bS-z","zapposPromoContainer":"cS-z","zapposPromoGroupContainer":"dS-z","promos":"eS-z","bottom":"fS-z","top":"gS-z","right":"hS-z","left":"iS-z"};